import React, { ReactElement } from 'react';

import { Notification } from '../../../types/entity.types';

import { formatUTCDate } from '../../../utils/date.util';
import { getClassNames, formatUsername } from '../../../utils/util';

import ProfilePicture from '../profile-picture/ProfilePicture';

import './notifications.scss';

type Props = {
  show: boolean;
  todayNotifications: Notification[];
  previousNotifications: Notification[];
};

const Notifications = ({ show, todayNotifications, previousNotifications }: Props): ReactElement => {
  const renderNotifications = (notifications: Notification[]): ReactElement[] =>
    notifications.map((notification: Notification): ReactElement => {
      const { profilePicture, username, message, date } = notification;

      return (
        <div className="notifications__notification" key={notification.externalReference}>
          <ProfilePicture src={profilePicture} alt={`${username} profile picture`} small />
          <div className="notifications__notification__content">
            <p className="notifications__notification__content__line-one">
              <b>{formatUsername(username)}</b> {message}
            </p>
            <p className="notifications__notification__content__line-two">{formatUTCDate(date)}</p>
          </div>
        </div>
      );
    });

  return (
    <div className={getClassNames('notifications', { show })} data-testid="notifications">
      {todayNotifications.length > 0 && <p className="notifications__header">TODAY</p>}
      {renderNotifications(todayNotifications)}

      {previousNotifications.length > 0 && <p className="notifications__header">PREVIOUS</p>}
      {renderNotifications(previousNotifications)}

      {todayNotifications.length === 0 && previousNotifications.length === 0 && (
        <div className="notifications__no-notifications">No notifications</div>
      )}
    </div>
  );
};

export default Notifications;
